import { Logo } from "../components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-obsidian grid grid-cols-1 lg:grid-cols-2" data-testid="auth-page">
      <div className="hidden lg:flex relative flex-col justify-between p-12 border-r border-white/5 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1462556791646-c201b8241a94?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Dark architecture"
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-obsidian/60 to-obsidian" />
        <a href="/" className="relative z-10 inline-block"><Logo size={36} /></a>
        <div className="relative z-10">
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-volt mb-4">Client Portal</p>
          <h2 className="font-display font-extrabold tracking-tighter leading-[0.95] text-5xl">
            ONE ID.
            <br />
            TOTAL <span className="text-volt">CONTROL.</span>
          </h2>
          <p className="mt-6 text-slate-400 max-w-sm leading-relaxed">
            Your unique Zork ID unlocks project briefs, live status tracking and your own accounts ledger.
          </p>
        </div>
        <p className="relative z-10 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600">© 2026 Zork Media</p>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <a href="/" className="lg:hidden inline-block mb-10"><Logo size={32} /></a>
          <h1 className="font-display font-bold tracking-tight text-3xl sm:text-4xl">{title}</h1>
          <p className="mt-2 text-sm text-slate-400">{subtitle}</p>
          <div className="mt-10">{children}</div>
          <div className="mt-8 text-sm text-slate-500">{footer}</div>
        </div>
      </div>
    </div>
  );
}
